import React, { Fragment, useContext } from 'react';

import AuthHeader from '../../container/Layout/AuthHeader';
import AuthFooter from '../../container/Layout/AuthFooter';

import { AuthContext } from '../../context/authContext';

import Sadface from '../../images/sadface.gif';

const NotFound = ({ history }) => {
  document.title = 'CrowdFarmer | Page Not Found';

  const { isAuthenticated } = useContext(AuthContext);

  return (
    <Fragment>
      <AuthHeader />
      <div className="Container mx-auto">
        <div className="container-inner mx-auto">
          <div className="flex items-center justify-center h-screen">
            <div className="text-center">
              <img src={Sadface} alt="Sad Face" className="w-1/2 m-auto" />
              <div className="flex flex-col">
                <p className="mx-auto text-left font-bold leading-snug">
                  <span>{`{`}</span>
                  <br />
                  <span className="p-3">
                    "error": "Oops! Looks like the page you're looking for doesn't exist!",
                  </span>
                  <br />
                  <span className="p-3">"statusCode": "404"</span>
                  <br />
                  <span className="p-3">"statusText": "Page Not Found!"</span>
                  <br />
                  <span>{`}`}</span>
                </p>
              </div>
              <p>
                If you're experiencing a critical issue, please send an{' email to '}
                <a
                  href="mailto:support@completefarmer.com?Subject=Having%20issues%20with%20dashboard"
                  target="_top"
                  className="font-bold text-cf-dark"
                >
                  support!
                </a>
              </p>
              <button
                className="mt-4 bg-cf-300 text-green-200 p-2 rounded shadow-cfw focus:outline-none"
                onClick={() => (isAuthenticated() ? history.push('/') : history.push('/'))}
              >
                Go to Back
              </button>
            </div>
          </div>
        </div>
      </div>
      <AuthFooter />
    </Fragment>
  );
};

export default NotFound;
